import script from "./DeclineOrders.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeclineOrders.vue?vue&type=script&setup=true&lang=ts"

import "./DeclineOrders.vue?vue&type=style&index=0&id=92ca6de6&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92ca6de6"]])

export default __exports__